export default "__VITE_ASSET__BTi7UMYx__"